import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { CrumpType } from '@wajeez-web/core/types';
import {
  AuthorsActions,
  ContentEntityActions,
  useContentDispatch,
  useContentSelector,
} from '@wajeez-web/stores/content';
import { useEffect } from 'react';

export const ContentEntitiesCrump: CrumpType = ({ params }): JSX.Element => {
  const type = params['type'];
  const entity = useContentSelector((s) =>
    s.contentEntityType.lookups.find((s) => s.name === type)
  );
  return (
    <ReturnTranslatedText
      text={`breadCrumbs.${entity?.displayNamePlural}`}
      origintext={entity?.displayNamePlural}
    />
  );
};

export const ContentEntityCrump: CrumpType = ({
  params,
  pathname,
}): JSX.Element => {
  const dispatch = useContentDispatch();
  const id = params['id'];
  const entity = useContentSelector((s) =>
    s.contentEntity.detailsHistory.find((s) => s.id === id)
  );
  useEffect(() => {
    if (!entity && id) {
      dispatch(ContentEntityActions.addContentEntityByIdForHistoryAsync(id));
    }
  }, [id]);

  return (
    <span>
      {pathname.includes('quotes') ? (
        <ReturnTranslatedText
          text={`breadCrumbs.Quotes`}
          origintext={`quotes`}
        />
      ) : null}

      <ReturnTranslatedText
        text={`breadCrumbs.${entity?.title}`}
        origintext={entity?.title}
      />
    </span>
  );
};

export const AuthorCrump: CrumpType = ({ params }): JSX.Element => {
  const dispatch = useContentDispatch();
  const id = params['id'];
  const entity = useContentSelector(
    (s) => s.authors.detailsHistory.find((s) => s.id == id) // IMPORTANT: == instead of ===
  );

  useEffect(() => {
    if (!entity && id) {
      dispatch(AuthorsActions.addAuthorByIdForHistoryAsync(Number(id)));
    }
  }, [id]);

  return (
    <ReturnTranslatedText
      text={`breadCrumbs.${entity?.name}`}
      origintext={entity?.name}
    />
  );
};

export const FlowCrump: CrumpType = ({ params }): JSX.Element => {
  const flowId = params['flowId'];
  const pageId = params['pageId'];

  const entity = useContentSelector((s) => s.flows.flowDetailsById.data);

  const crump = entity?.id?.toString() === flowId ? entity?.flowName : '';

  return (
    <ReturnTranslatedText text={`breadCrumbs.${crump}`} origintext={crump} />
  );
};

export const FlowCrumpV2: CrumpType = ({ params }): JSX.Element => {
  const flowId = params['flowId'];

  const flowV2 = useContentSelector(
    ({ flows }) => flows.flowDetailsByIdV2.data
  );

  const crump = flowV2?.id?.toString() === flowId ? flowV2?.flowName : '';

  return (
    <ReturnTranslatedText text={`breadCrumbs.${crump}`} origintext={crump} />
  );
};
